/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "图集",
        type: "module-name"
    },
    {
        key: "link_data",
        name: "链接",
        type: "img-set"
    }
];
export default config;